import React, { useState, useEffect } from "react";
import axios from "axios";
// @material-ui/core components

// core components
import GridContainer from 'components/Grid/GridContainer.js';

import WorkCalendar from 'views/aps/tables/WorkCalendar';
import ProductionPlan from 'views/aps/tables/ProductionPlan';
import Inventory from "views/aps/tables/Inventory";

export default function ProductionList(props) {
    const { factory, onSave } = props;
    const [operationSelect, setOperationSelect] = useState({});

    useEffect(() => {
        axios.get('aps/list/operation', { params: factory }).then(response => {
            const productSelect = [...new Set(response.data.data.map(item => item.product_id))].map(item => ({ label: item, value: item }));
            setOperationSelect({ 'product_id': productSelect });
        });
    }, []);
    const handleSave = function () {
        if (onSave) {
            onSave();
        }
    }
    return (
        <GridContainer spacing={0}>
            <WorkCalendar factory={factory} onSave={handleSave} />
            <ProductionPlan factory={factory} operationSelect={operationSelect} onSave={handleSave} />
        </GridContainer>
    );
}